import * as api from '@/network/api/menu.api.js'

/** requests menu for our user
@payload {String} - helper for mock to "fetch" when on company vs particular
@return {promise} - menu request
*/
export const menuFetch = async (context, payload) => {
    if (context.state.menu && context.state.menu.length) return

    const res = await api.menu(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_MENU_INFO', data)
    }
    return res
}

/** requests submenu for our user
@return {promise} - submenu request
*/
export const submenuFetch = async (context, payload) => {
    const res = await api.submenu()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_SUB_MENU_INFO', data)
    }
    return res
}

/** updates menu to new one
@return {void}
*/
export const updateMenu = async (context, payload) => {
    context.commit('SAVE_MENU_INFO', payload)
}
